export default __webpack_public_path__ + "static/media/offensive.2687355a.png";